import { NAV_FEATURES } from '../features.registry';

export const ADMIN_FEATURES = [

    NAV_FEATURES.DASHBOARD,
    NAV_FEATURES.ROUTES,
    NAV_FEATURES.FEATURES,
    NAV_FEATURES.SCREEN,
    NAV_FEATURES.SYNC,
    NAV_FEATURES.BUSINESS_CATEGORIES,
    NAV_FEATURES.BUSINESS_TYPES,
    NAV_FEATURES.PERSON_ROLES,
    NAV_FEATURES.TRANSACTION_TYPES,
    NAV_FEATURES.UNITS_OF_MEASURES,
    NAV_FEATURES.SHAPES,
    NAV_FEATURES.ITEM_TYPES,
    NAV_FEATURES.CULTURE_CATEGORIES,
    NAV_FEATURES.SPECIES_TYPES,
    NAV_FEATURES.WATER_TYPES,
    NAV_FEATURES.SOIL_TYPES,
    NAV_FEATURES.ACTIVITIES_LIST,
    NAV_FEATURES.BROOD_BREEDERS,
    NAV_FEATURES.BROOD_LINES,
    NAV_FEATURES.OBSERVATION_TYPES,
    NAV_FEATURES.TREATMENT_TYPES,
    NAV_FEATURES.POND_TYPES,
    NAV_FEATURES.POND_USAGES,
    NAV_FEATURES.QUICK_REGISTRATION,
    NAV_FEATURES.BUSINESS_ENTITIES,
    NAV_FEATURES.PERSONS,
] as const;

export const getAdminFeatures = () => Array.from(ADMIN_FEATURES);